import React, { useEffect } from 'react'

//components
import Navbar from '../components/Navbar/Navbar'
import Banner from '../components/Banner/LoanBanner'
import Biodata from '../components/CustomerInformation/BioData'
import Footer from '../components/Footer/Footer'
  
const BioData = () => {
    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'auto'})
    }, []);

    return (
        <>
            <Navbar /> 
            <Banner /> 
            <Biodata />
            <Footer />
        </>
    )
}

export default BioData
